import React from "react";
import { Button } from "../../../components/ui/button";
import { MessageSquare } from "lucide-react";
import { Card, CardContent } from "../../../components/ui/card";
import { useNavigate } from "react-router";

const TestimonialPage = () => {
  const navigate = useNavigate();
  const testimonials = [
    {
      quote: "Pro Teams has revolutionized how we manage our business. The ROI was instant!",
      author: "Sarah Johnson",
      role: "CEO, CleanCo Inc."
    },
    {
      quote: "The best investment we made for our operations. Customer support is exceptional!",
      author: "Michael Chen",
      role: "Owner, GreenMaids"
    }
  ];

  return (
    <div className="mt-40 space-y-6 w-full">
      <Card className="bg-background dark:bg-card border">
        <CardContent className="p-32">
          <div className="text-center space-y-4">
            <h2 className="text-2xl font-bold text-foreground">
              Need help choosing?
            </h2>
            <p className="text-muted-foreground max-w-2xl mx-auto">
              Our team of experts can help you find the perfect plan for your business needs and answer any questions.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center pt-8">
              <Button 
                variant="default"
                onClick={() => navigate("/dashboard")}
                className="bg-green-600 hover:bg-green-700 dark:bg-green-600 dark:hover:bg-green-700"
              >
                <MessageSquare className="h-4 w-4 mr-8" />
                Contact Sales
              </Button>
              <Button 
                variant="outline"
                className="border-border hover:bg-muted"
                onClick={() => navigate("/dashboard")}
              >
                Return to Dashboard
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Testimonials */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {testimonials.map((testimonial, index) => (
          <Card key={index} className="bg-background dark:bg-card border">
            <CardContent className="p-24">
              <div className="flex flex-col h-full">
                <div className="mb-16">
                  <svg 
                    className="h-8 w-8 text-green-600 dark:text-green-500" 
                    fill="currentColor" 
                    viewBox="0 0 32 32"
                  >
                    <path d="M10 8c-3.3 0-6 2.7-6 6v10h8V14h-6c0-2.2 1.8-4 4-4V8zm14 0c-3.3 0-6 2.7-6 6v10h8V14h-6c0-2.2 1.8-4 4-4V8z"/>
                  </svg>
                </div>
                <p className="text-foreground text-base mb-16 flex-grow leading-relaxed">
                  {testimonial.quote}
                </p>
                <div className="pt-8 border-t border-border">
                  <p className="font-semibold text-foreground text-sm">
                    {testimonial.author}
                  </p>
                  <p className="text-muted-foreground text-xs">
                    {testimonial.role}
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default TestimonialPage;